$(() => {
  console.log("%c"+
    "                                   _           \n"+
    " _ __ ___ _ __ ___   _____   _____| |__   __ _ \n"+
    "| '__/ _ \\ '_ ` _ \\ / _ \\ \\ / / _ \\ '_ \\ / _` |\n"+
    "| | |  __/ | | | | | (_) \\ V /  __/ |_) | (_| |\n"+
    "|_|  \\___|_| |_| |_|\\___/ \\_/ \\___|_.__/ \\__, |\n"+
    "                                         |___/ \n"+
    "\n"+
    " 🐱‍💻🐱‍💻🐱‍💻🐱‍💻🐱‍💻🐱‍💻🐱‍💻🐱‍💻🐱‍💻🐱‍💻🐱‍💻🐱‍💻🐱‍💻\n"+
    "\n"+
    " [ Want to build the future of visual AI? ]\n"+
    " [  ➡️ www.remove.bg/jobs                  ]\n"+
    " [  ➡️ jobs@kaleido.ai                     ]\n",

    "font-family:monospace"
  )
});